import { API } from 'aws-amplify'

import * as actionTypes from './actionTypes';
import modalNames from '../../util/modalNames';

const basePath = '/recipients';
const apiName = 'recipients';
const actions = {
  checkRecipient: async ({ commit }, payload) => {
    console.log('PAYLOAD: ', payload);
    const { vm, recips } = payload;
    const opts = {
      body: recips,
    };
    const path = `${basePath}/check`;
    commit(actionTypes.CHECK_RECIPIENT_START, recips);
    try {
      const res = await API.post(apiName, path, opts);
      console.log('Check Recip - res: ', res);
      commit(actionTypes.CHECK_RECIPIENT_SUCCESS, res);
      //Dispatch Create Recipient here
      if (res.isDuplicate === false) {
        return vm.$store.dispatch('createRecipient', payload);
      }

      // TODO: THIS MODAL ID SHOULD BE SOMETHING ELSE
      vm.$bvModal.show(modalNames.DUPLICATE_WARNING_MODAL);
    } catch (err) {
      const errorMsg = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Please try again.';
      commit(actionTypes.CHECK_RECIPIENT_FAIL, errorMsg);
    }
  },
  createRecipient: async ({ commit }, payload) => {
    const { vm, recips, cb } = payload;
    const opts = {
      body: recips,
    };
    commit(actionTypes.CREATE_RECIPIENT_START);
    try {
      const res = await API.post(apiName, basePath, opts);
      console.log('Create Recip res: ', res);
      commit(actionTypes.CREATE_RECIPIENT_SUCCESS, res);
      vm.$store.dispatch('listRecipients');
      if (cb) cb(); // clear form data
    } catch (err) {
      const errorMsg = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Please try again.';
      commit(actionTypes.CREATE_RECIPIENT_FAIL, errorMsg);
    }
  },
  listRecipients: async ({ commit, state }) => {
    commit(actionTypes.LIST_RECIPIENTS_START);
    const query = `?organization=${state.user.attributes['custom:organization']}`;
    const path = `${basePath}${query}`;
    try {
      const res = await API.get(apiName, path, {});
      console.log('List Recips res: ', res);
      commit(actionTypes.LIST_RECIPIENTS_SUCCESS, res);
    } catch (err) {
      const errorMsg = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Please try again.';
      commit(actionTypes.LIST_RECIPIENTS_FAIL, errorMsg);
    }
  },
  updateRecipient: async ({ commit }, payload) => {
    commit(actionTypes.UPDATE_RECIPIENT_START);
    const opts = {
      body: payload,
    };
    try {
      const res = await API.put(apiName, basePath, opts);
      console.log('Update Recip - res: ', res);
      commit(actionTypes.UPDATE_RECIPIENT_SUCCESS, res);
    } catch (err) {
      const errorMsg = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Please try again.';
      commit(actionTypes.UPDATE_RECIPIENT_FAIL, errorMsg);
    }
  },
  deleteRecipient: async ({ commit }, payload) => {
    console.log('Delete Recipient Action');
    commit(actionTypes.DELETE_RECIPIENT_START);
    const { vm, recip } = payload;
    const path = `${basePath}/${recip}`;
    const opts = {};
    try {
      const res = await API.del(apiName, path, opts);
      console.log('Delete Recip - res: ', res);
      commit(actionTypes.DELETE_RECIPIENT_SUCCESS, res);
      vm.$store.dispatch('listRecipients');
    } catch (err) {
      console.log('Delete Recipient Error', err);
      const errorMsg = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Please try again.';
      commit(actionTypes.DELETE_RECIPIENT_FAIL, errorMsg);
    }
  },
  getRecipient: async ({ commit }, payload) => {
    commit(actionTypes.GET_RECIPIENT_START);
    const path = `${basePath}/${payload}`;
    const opts = {};
    try {
      const res = await API.get(apiName, path, opts);
      console.log('Get Receip - res: ', res);
      commit(actionTypes.GET_RECIPIENT_SUCCESS, res);
    } catch (err) {
      const errorMsg = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Please try again.';
      commit(actionTypes.GET_RECIPIENT_FAIL, errorMsg);
    }
  },
  getRecipientCount: async ({ commit }) => {
    commit(actionTypes.GET_RECIPIENT_COUNT_START);
    const path = `${basePath}/count`;
    const opts = {};
    try {
      const res = await API.get(apiName, path, opts);
      commit(actionTypes.GET_RECIPIENT_COUNT_SUCCESS, res.recipientCount);
    } catch (err) {
      const errorMsg = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Please try again.';
      commit(actionTypes.GET_RECIPIENT_COUNT_FAIL, errorMsg);
    }
  },
  setRecipToDelete: ({ commit }, payload) => {
    commit(actionTypes.SET_RECIP_TO_DELETE, payload);
  },
  clearRecipState: ({ commit }) => {
    commit(actionTypes.CLEAR_RECIP_UPDATE_STATE);
  }
};

export default actions;
